export default Symbol('events');